export default __webpack_public_path__ + "static/media/poster7.44b9a373.png";